import { render } from "./IndicadorNumero.vue?vue&type=template&id=2184c9a4&scoped=true&ts=true"
import script from "./IndicadorNumero.vue?vue&type=script&lang=ts"
export * from "./IndicadorNumero.vue?vue&type=script&lang=ts"

import "./IndicadorNumero.vue?vue&type=style&index=0&id=2184c9a4&scoped=true&lang=css"

import exportComponent from "D:\\DefesaCivil\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2184c9a4"]])

export default __exports__